import React, { useEffect } from 'react'
import Button from '../components/Button'
import RadioButtonQuestion from '../components/RadioButtonQuestion'
import {questions} from '../data/json'


const TestQuestions3 = ({prevStep, nextStep, handleChange, values}) => {

  useEffect(() => {
    document.documentElement.scrollTo({
      top: 0,
      left: 0,
    });
  }, [])

  const Continue = e => {
    e.preventDefault();
    nextStep();
  }

  const GoBack = e => {
    e.preventDefault();
    prevStep();
  }

  return (
    <div className='__test-questions'>
      <h2>Strategi </h2>
      <p>Det er vigtigt at have en strategisk tilgang til at opbygge modstandsdygtighed, for at kunne ensrette arbejdet med den overordnede strategi i jeres virksomhed. Dette hjælper jer med at identificere og prioritere de områder, hvor der er størst risiko for negative påvirkninger, samt at udvikle planer og ressourcer til at håndtere disse risici. En strategisk tilgang til modstandsdygtighed kan også bidrage til at man står bedre for fremtidige udfordringer og kan udnytte muligheder, når de opstår. </p>
        <form>
          <RadioButtonQuestion isChecked={values.qst3_1} title={questions.strategy.qst_1} name="qst-strategy_1" value={values} onChange={handleChange('qst3_1')}/>
          <RadioButtonQuestion isChecked={values.qst3_2} title={questions.strategy.qst_2} name="qst-strategy_2" value={values} onChange={handleChange('qst3_2')}/>
          <RadioButtonQuestion isChecked={values.qst3_3} title={questions.strategy.qst_3} name="qst-strategy_3" value={values} onChange={handleChange('qst3_3')}/>
          <RadioButtonQuestion isChecked={values.qst3_4} title={questions.strategy.qst_4}name="qst-strategy_4" value={values} onChange={handleChange('qst3_4')}/>
          <div className='__prev-next-buttons'>
            <Button buttonText='Tilbage' onClick={GoBack} />
            <Button buttonText='Næste' onClick={Continue} disabled={(values.qst3_1 !== '' && values.qst3_2 !== '' && values.qst3_3 !== '' && values.qst3_4 !== '' ) ? false : true} />
          </div>
        </form>
    </div>

  )
}

export default TestQuestions3